<template>
  <!-- 资质列表 -->
  <div>
    <div class="fourthStep">
      <el-form
        ref="extTable"
        :model="{ extTable }"
        :rules="tableRules"
        props
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item class="addTabIndex" label-width="0px" label="" prop="">
          <div class="table_title">业务承揽能力</div>
          <el-table
            border
            :data="extTable"
            class="ccui-form-child-table"
            max-height="99999"
          >
          <el-table-column
            type="index"
            label="序号"
            width="60"
            fixed>
          </el-table-column>
          <el-table-column min-width="150" prop="quantity" label="同期承揽工程最大数量">
            <template slot-scope="scope">
              <el-form-item
                :prop="`extTable.${scope.$index}.quantity`"
                :rules="tableRules.quantity"
              >
                <el-input
                  style="width: 260px"
                  v-model="scope.row.quantity"
                  v-input.int
                  placeholder="请输入"
                  clearable
                  maxlength="5"
                />
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
            min-width="150"
            prop="amount"
            label="同期承揽工程最大合同金额"
          >
            <template slot-scope="scope">
              <el-form-item
                :prop="`extTable.${scope.$index}.amount`"
                :rules="tableRules.amount"
              >
                <el-input
                  style="width: 260px"
                  v-model="scope.row.amount"
                  v-input.float="6"
                  placeholder="请输入"
                  clearable
                  maxlength="21"
                />
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="附件" min-width="150">
            <!-- :http-request="(file)=>{return imggreySuccess(file ,scope.row)}" -->
            <template slot-scope="scope">
              <!-- evidenceFile -->
              <!-- {{getUrl(scope)}} -->
              <el-form-item
                :prop="`extTable.${scope.$index}.capacityFileUploadId`"
                :rules="tableRules.capacityFileUploadId"
                :ref="`formItem${scope.$index}`"
              >
                <el-upload
                  class="upload_content"
                  :file-list="scope.row.fileList?scope.row.fileList:[]"
                  :limit="1"
                  :on-success="(response, file, fileList) => handleSuccess(response, file, fileList, scope.row.id, scope.$index)"
                  :action="importFileUrl"
                  :on-remove="(file, fileList) => handleRemove(file, fileList, scope.row.id)"
                >
                  <!-- :show-file-list="false" -->
                  <!-- list-type="text" -->
                  <span
                    v-if="!scope.row.capacityFileUploadId"
                    style="font-size:7px;padding:3px 10px;border-radius:5px;color:white;background:red;"
                    >上传</span
                  >
                  <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div> -->
                </el-upload>
              </el-form-item>
            </template>
          </el-table-column>
            <el-table-column prop="remark" label="操作" width="100px" fixed="right">
              <template slot-scope="scope">
                <span
                  style="color: red; cursor: pointer"
                  @click="deleteItem(scope)"
                  >删除</span
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label-width="0px" label="">
          <div class="addBtn" @click="addTable()">+添加履约能力</div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
// import { getBuildingGradeDict } from "@/api/subcontractor-register";
export default {
  props: {
    extTable: {
      type: Array,
      default: []
    }
  },
  components: {
  },
  computed: {
  
  },
  data() {
    return {
      checkOut: false,
      fileList: [],
      tableRules: {
        quantity: [{ required: true, message: "请输入同期承揽工程最大数量", trigger: "blur" }],
        amount: [{ required: true, message: "请输入同期承揽工程最大合同金额", trigger: "blur" }],
        capacityFileUploadId: [{ required: true, message: "请上传附件", trigger: "change" }]
      },
      importFileUrl:
        this.$addUrlPerFix(process.env.VUE_APP_UPLOAD_URL) +
        "/apis/sra/reg/users/signup/uploadFileToOss", // 上传地址
      currentId: "",
    };
  },
  mounted() {
    // getBuildingGradeDict({}).then(res => {
    //   if (res.data.code === "0") {
    //     this.qualificationLevel = res.data.data;
    //   }
    // });
    this.extTable.forEach(item => {
      if(item.capacityFileUploadId){
        item.fileList = [{
          name: item.capacityFileName,
          url: item.capacityFileUploadId
        }]
      }
    })
  },
  methods: {
    // 新增
    addTable() {
      if (this.extTable && this.extTable.length === 0) {
        this.extTable.push({
          id: 1,
          quantity: "",
          amount: "",
          capacityFileUploadId: "",
          capacityFileName: "",
          fileList: []
        });
      } else {
        this.extTable.push({
          id: this.extTable[this.extTable.length - 1].id + 1,
          quantity: "",
          amount: "",
          capacityFileUploadId: "",
          capacityFileName: "",
          fileList: []
        });
      }
    },
    handleSuccess(response, file, fileList, id, index) {
      let _this = this
      this.extTable.forEach(item => {
        if (id === item.id) {
          item.fileList = [{
            name: response.data[0].fileName,
            url: response.data[0].downloadUrl
          }]
          this.$set(item, "capacityFileUploadId", response.data[0].uploadId);
          this.$set(item, "capacityFileName", response.data[0].fileName);
          let fromName = "formItem" + index
          _this.$refs[fromName].clearValidate()
        }
      });
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    handleRemove(file, fileList, id) {
      this.extTable.forEach(item => {
        if (id === item.id) {
          this.$set(item, "capacityFileUploadId", "");
          this.$set(item, "capacityFileName", "");
          delete item.fileList;
        }
      });
    },
    ruleFun() {
      this.$refs["extTable"].validate(valid => {
        if (valid) {
          this.checkOut=  true;
        } else {
          this.$refs.extTable.$el.scrollIntoView({
            block: "center",
            behavior: "smooth",
          });
          this.checkOut=  false;
        }
      });
    },
    deleteItem(scope) {
      this.extTable.filter((item, index) => {
        if (item.id === scope.row.id) {
          this.extTable.splice(index, 1);
        }
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.fourthStep {
  display: flex;
  align-items: center; /*垂直居中*/
  justify-content: center; /*水平居中*/
}
.el-table /deep/th.gutter {
  display: table-cell !important;
}
.addBtn {
  cursor: pointer;
  margin: 20px 0px 10px 0px;
  width: 1006px;
  height: 32px;
  line-height: 32px;
  border: 1px dashed #eee;
  border-radius: 4px;
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #252631;
}
.addTabIndex {
  width: 100%;
  display: flex;
  align-items: center; /*垂直居中*/
  justify-content: center; /*水平居中*/
}
.addTabIndex /deep/.tbody tr {
  height: 45px !important;
}
/deep/ .el-input--suffix .el-input__inner {
  // padding-right: 25px;
}
/deep/ .el-input__suffix {
  // right: 0px;
  .el-input__clear {
    width: 23px;
  }
}
.addTabIndex /deep/.el-table {
  width: 1006px;
  margin: 0 auto;
  border-bottom: none;
  tbody tr {
    height: 60px !important;
  }
  .addBtn {
    width: 100%;
    height: 32px;
    line-height: 32px;
    border: 1px dashed #eee;
    border-radius: 4px;
    margin: 16px 0;
    text-align: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #252631;
  }

  th>.cell:before{
    content: "*";
    color: red;
    margin-right: 5px;
  }
  th:nth-child(5)>.cell:before{
    content: "";
    margin-right: 5px;
  }
  th:nth-child(1)>.cell:before{
    content: "";
    margin-right: 5px;
  }
}
.table_title {
  width: 100%;
  line-height: 40px;
  border: 1px solid #EDF2FC;
  border-bottom: 0px;
  box-sizing: border-box;
  text-align: center;
  font-size: 15px;
  font-weight: 600;
  background-color: #f8fafd;
}
.upload_content {
  position: relative;
  // /deep/ .el-upload {
  //   width: 100px;
  //   span {
  //     width: 100px;
  //   }
  // }
  /deep/ .el-upload-list {
    position: absolute;
    top: 0px;
    width: 260px
  }
}


</style>
